import {Step} from "react-joyride";
import {createAction} from "redux-act";

export const openTutorial = createAction();
export const closeTutorial = createAction();
export const setActiveStep = createAction<number>();
export const setIsOpenMobileNavigation = createAction<boolean>();

export const openTutorialSingleStep = createAction<Step>();
export const closeTutorialSingleStep = createAction();
